// extracted by mini-css-extract-plugin
module.exports = {"addMesage":"Posts_addMesage__V__7-","button":"Posts_button__14NYx"};